import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function NotForEveryone() {
  return <section className="px-6 py-5 max-w-4xl mx-auto" data-id="element-265">
      <FadeIn data-id="element-266">
        <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-sm border border-[#4A5D3A]/10 p-6 md:p-10" data-id="element-267">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-[#2D2A26] text-center mb-6" data-id="element-268">
            Este método NO es para todas las personas
          </h2>

          <p className="text-lg md:text-xl font-bold text-[#9B4F2B] mb-4" data-id="element-269">
            Este método NO es para ti si:
          </p>

          <div className="space-y-3 mb-8" data-id="element-270">
            <p className="text-lg md:text-xl text-[#2D2A26]/80 flex items-start gap-3" data-id="element-271">
              <span className="text-[#9B4F2B] font-bold shrink-0" data-id="element-272">✘</span>
              Buscas una solución mágica sin hacer nada
            </p>
            <p className="text-lg md:text-xl text-[#2D2A26]/80 flex items-start gap-3" data-id="element-273">
              <span className="text-[#9B4F2B] font-bold shrink-0" data-id="element-274">✘</span>
              No estás dispuesto a preparar una infusión simple
            </p>
            <p className="text-lg md:text-xl text-[#2D2A26]/80 flex items-start gap-3" data-id="element-275">
              <span className="text-[#9B4F2B] font-bold shrink-0" data-id="element-276">✘</span>
              Esperas resultados sin aplicar el protocolo
            </p>
          </div>

          <p className="text-lg md:text-xl text-[#2D2A26]" data-id="element-277">
            Pero <strong className="text-[#4A5D3A]" data-id="element-278">SI es para ti</strong> si
            quieres
          </p>
          <p className="text-xl md:text-2xl font-serif font-bold text-[#4A5D3A] mt-2" data-id="element-279">
            darle a tu sistema nervioso una señal real de calma
          </p>
          <p className="text-xl md:text-2xl font-serif font-bold text-[#4A5D3A]" data-id="element-280">
            antes de dormir.
          </p>
        </div>
      </FadeIn>
    </section>;
}